module.exports = __webpack_public_path__ + "img/44bafe3.png";